import googleCalendarIssuesUrl from './googleCalendarIssuesComponent.html';

class GoogleIssuesCtrl {
  constructor(Authentication, GoogleCalendarUtils) {
    'ngInject';

    Object.assign(this, { Authentication, GoogleCalendarUtils });
  }

  get shouldShowPrompt() {
    return Boolean(
      this.Authentication.isOrgFeatureEnabled('googleCalendarSync') &&
        this.Authentication.user.settings.googleCalendarSyncEnabled &&
        this.Authentication.googleCalendarExpired &&
        !this.GoogleCalendarUtils.calendarWarningDismissed
    );
  }

  focusGoogleWindow() {
    this.GoogleCalendarUtils.focusWindow();
  }

  async fixGoogleCal() {
    if (this.googleAuthenticationInProgress) {
      this.GoogleCalendarUtils.focusWindow();
      return;
    }

    try {
      this.googleAuthenticationInProgress = true;
      const code = await this.GoogleCalendarUtils.openGoogleCalendarModal();
      await this.GoogleCalendarUtils.authenticateGoogleCalendar(code);
    } finally {
      this.googleAuthenticationInProgress = false;
    }
  }

  dismiss() {
    this.GoogleCalendarUtils.calendarWarningDismissed = true;
    this.Authentication.syncSettings({
      ...this.Authentication.user.settings,
      googleCalendarSyncEnabled: false,
    });
  }
}

export default {
  templateUrl: googleCalendarIssuesUrl,
  controllerAs: 'ctrl',
  controller: GoogleIssuesCtrl,
  bindings: {
    anotherShown: '<',
  },
};
